import DataInvoice from "./DataInvoice";

export default function DataSummaryInvoice({ row, index }) {
  return <DataInvoice row={row} index={index} active="summary" />;
}
